<template>
  <div>
    <el-time-picker v-model="time" placeholder="任意时间点" @change="postTime" style="width: 12em">
    </el-time-picker>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Date,
    }
  },
  data() {
    return {
      time: this.value,
    };
  },
  methods: {
    postTime() {
      if(this.time) {
        let time = this.formatDate(this.time);
        this.$emit('time', time);
      } else {
        this.$emit('time', "");
      }
    },
    formatDate(date) {
      let d = (date.getHours() < 10?'0'+date.getHours():date.getHours())+":"+(date.getMinutes() < 10?'0'+date.getMinutes():date.getMinutes())+":"+(date.getSeconds() < 10?'0'+date.getSeconds():date.getSeconds());
      return d;
    }
  },
  created() {
    this.postTime();
  }
};
</script>

<style>

</style>
